// extracted by mini-css-extract-plugin
module.exports = {"hero":"tag--hero--3ukZZ","tags":"tag--tags--2mzyf","totalCount":"tag--totalCount--3L51q","pagination":"tag--pagination--Kimk_"};